import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const FilterButton = (props) => {

  function handleClick() {
    props.onClick( props.type )
  }

  return (
    <button 
      onClick={handleClick} 
      data-active={props.type == props.current}
      data-disabled={props.loading}
      className="c-vacancies-filter-button c-button c-button--dark-gray-tag"
    >
      {props.name}
    </button>
  )
}

export default FilterButton



// WEBPACK FOOTER //
// ./src/js/vacancies/components/FilterButton.js